(function () {
  "use strict";
  if (window.__nagColorLightbox) return;
  window.__nagColorLightbox = 1;

  /* ==========================================================
     NAGAIA colour gallery  v7  (2026-08-24)

     v7 = v5 + a bigger photo + 2x tap zoom.
       CAPS 440->560 desktop / 360->460 mobile, and 600/500 in KIT mode,
       where the size picker is replaced by one progress line and hands back
       ~40px. Total column height is the same in both modes on purpose.
       MAIN SRC 900->1200 IN THE SAME BREATH: a 560px cap needs 1120px on a
       2x screen, so moving the cap without the src would have made the photo
       genuinely softer. NEVER move one of those two numbers alone.
       ZOOM is 2x, tap-driven, described where it is implemented below.
       Layout is untouched -- still ONE CENTRED COLUMN.

     v5 changes ONE thing: every CDN src now goes through sized() before
     it reaches an <img>. No markup, no layout, no behaviour. See the
     comment on sized() for why the numbers are what they are.

     ONE gallery, two callers:
       COLLECTION  the photo badge on the colour card opens it with a size
                   picker and Add to bag. Wired by [data-nv6] delegation.
       KIT BUILDER the magnifier on a swatch opens the SAME gallery with a
                   kit action instead -- add to / remove from the kit. It
                   calls window.NagaiaColorGallery.open(). Nothing about the
                   collection path changes.

     Also hides the retired .nv5-dots frame indicator. NOTHING ELSE.

     NEVER TOUCH FROM HERE -- each was settled separately:
       which media feed card frames 1/2/3 | .nv2-owned-badge | the
       0.5oz/1oz pill (applySize in nagaia-05oz.js) | the mini cart
       .nv2-fc | the quick-add queue, its 429 backoff and its toast |
       the kit tiers, tabs, curated whitelists, baseSku(), the selected
       preview strip or the kit's own add-to-cart.

     TWO RULES THE v1/v2 DEFECTS EARNED, BOTH STILL IN FORCE:

       NO PERCENTAGE HEIGHTS. v1 sized the photo with height:100% inside a
       flex column whose parent had no definite height, so it resolved to
       the natural size: enormous on desktop, collapsed on mobile, controls
       off screen. Every cap here is vh or px, and the column carries
       margin:auto so it stays centred whatever the flex context turns out
       to be. The layout is ONE CENTRED COLUMN -- v2 quietly rebuilt it as
       photo-left / controls-right, which was never shown or agreed, and it
       was reverted. Do not redesign it here.

       NOTHING LOAD-BEARING IN THIS STYLESHEET FOR SERVER-RENDERED NODES.
       The badge and the card hover frame are printed by
       snippets/product-block-color.liquid and this file is appended at
       runtime, so anything essential here paints one frame late -- in v1
       that showed as a wide unstyled theme button. Their geometry is
       inline in the snippet; the rules below may only add polish.

     PHOTOS ARE 9:16 (1080x1920); swatches are square. The card has to
     crop; this must not -- hence width:auto with a height cap only.
     ========================================================== */

  var css = ""
  + ".nv5-dots{display:none!important}"
  + ".product-block:hover .nv6-hov{display:block!important}"
  + ".product-block:hover .nv6-hov ~ .product-block__primary-image{visibility:hidden}"
  + ".nv6-hov img{width:100%;height:100%;object-fit:cover;display:block}"
  + ".nv6-badge{transition:transform .12s ease}"
  + ".nv6-badge:hover{transform:scale(1.07)}"
  + ".nv6-badge svg{width:14px;height:14px;display:block;flex:none}"
  + ".nv6-badge span{display:block}"
  + ".nv6-lb{position:fixed;inset:0;z-index:10000;background:rgba(16,14,13,.95);display:none;"
  + "padding:24px 16px;box-sizing:border-box;overflow-y:auto;"
  + "font-family:'Inter Tight',sans-serif;-webkit-font-smoothing:antialiased}"
  + ".nv6-lb.show{display:flex;align-items:center;justify-content:center}"
  + ".nv6-x{position:fixed;top:16px;right:16px;z-index:2;width:44px;height:44px;border-radius:50%;"
  + "background:rgba(255,255,255,.16);border:none;color:#fff;cursor:pointer;display:flex;"
  + "align-items:center;justify-content:center;padding:0;margin:0;min-width:0;min-height:0}"
  + ".nv6-x:hover{background:rgba(255,255,255,.3)}"
  + ".nv6-x svg{width:18px;height:18px}"
  + ".nv6-box{display:flex;flex-direction:column;align-items:center;gap:14px;"
  + "width:100%;max-width:430px;margin:auto}"
  + ".nv6-media{position:relative;line-height:0;max-width:100%;overflow:hidden;"
  + "border-radius:14px;touch-action:pan-y}"
  + ".nv6-lb.nv6-zoomed .nv6-media{touch-action:none;cursor:grab}"
  + ".nv6-zoom{position:absolute;top:10px;left:10px;z-index:2;width:36px;height:36px;"
  + "border-radius:50%;background:rgba(20,18,17,.55);border:none;color:#fff;cursor:pointer;"
  + "display:flex;align-items:center;justify-content:center;padding:0;margin:0;"
  + "min-width:0;min-height:0;-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px)}"
  + ".nv6-zoom:hover{background:rgba(20,18,17,.82)}"
  + ".nv6-zoom svg{width:19px;height:19px}"
  + ".nv6-media img{display:block;width:auto;height:auto;max-width:100%;"
  + "max-height:min(62vh,560px);border-radius:14px;background:#241f1d;"
  + "transition:transform .2s ease}"
  + ".nv6-lb.nv6-kit .nv6-media img{max-height:min(66vh,600px)}"
  + ".nv6-nav{position:absolute;top:50%;transform:translateY(-50%);width:44px;height:44px;"
  + "border-radius:50%;background:rgba(20,18,17,.55);border:none;color:#fff;cursor:pointer;"
  + "display:flex;align-items:center;justify-content:center;padding:0;margin:0;"
  + "min-width:0;min-height:0;-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px)}"
  + ".nv6-nav:hover{background:rgba(20,18,17,.82)}"
  + ".nv6-nav svg{width:20px;height:20px}"
  + ".nv6-prev{left:10px}.nv6-next{right:10px}"
  + ".nv6-cnt{position:absolute;left:50%;bottom:10px;transform:translateX(-50%);"
  + "background:rgba(20,18,17,.6);color:#fff;font-size:11.5px;font-weight:700;letter-spacing:.05em;"
  + "padding:5px 11px;border-radius:20px;line-height:1;white-space:nowrap;"
  + "-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px)}"
  + ".nv6-panel{width:100%;display:flex;flex-direction:column;gap:11px;color:#fff}"
  + ".nv6-t{font-size:19px;font-weight:800;letter-spacing:-.025em;line-height:1.2;text-align:center}"
  + ".nv6-t small{display:block;font-size:12px;font-weight:500;opacity:.55;margin-top:4px;letter-spacing:0}"
  + ".nv6-th{display:flex;gap:6px;overflow-x:auto;max-width:100%;padding-bottom:4px;"
  + "justify-content:center;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.25) transparent}"
  + ".nv6-th::-webkit-scrollbar{height:3px}"
  + ".nv6-th::-webkit-scrollbar-thumb{background:rgba(255,255,255,.25);border-radius:2px}"
  + ".nv6-th button{all:unset;flex:none;cursor:pointer;line-height:0;border-radius:8px}"
  + ".nv6-th img{width:42px;height:42px;border-radius:8px;object-fit:cover;display:block;"
  + "opacity:.4;border:2px solid transparent;box-sizing:border-box;transition:opacity .12s}"
  + ".nv6-th button:hover img{opacity:.75}"
  + ".nv6-th button.on img{opacity:1;border-color:#FF3F9E}"
  + ".nv6-size{display:flex;gap:8px}"
  + ".nv6-sz{flex:1;min-width:0;background:rgba(255,255,255,.07);"
  + "border:1.8px solid rgba(255,255,255,.16);border-radius:13px;padding:11px 6px 10px;"
  + "cursor:pointer;text-align:center;color:#fff;font-family:inherit;transition:all .15s}"
  + ".nv6-sz:hover{border-color:rgba(255,255,255,.42)}"
  + ".nv6-sz.on{border-color:#FF3F9E;background:rgba(255,63,158,.16)}"
  + ".nv6-sz b{display:block;font-size:13px;font-weight:800}"
  + ".nv6-sz .p{display:block;font-size:16px;font-weight:800;margin-top:3px;white-space:nowrap}"
  + ".nv6-sz .p s{font-size:11.5px;font-weight:500;opacity:.5;margin-left:5px}"
  /* kit mode: one progress line where the size picker would be */
  + ".nv6-prog{text-align:center;font-size:12px;font-weight:600;color:rgba(255,255,255,.7)}"
  + ".nv6-prog b{color:#fff}"
  + ".nv6-atc{width:100%;background:#FF3F9E;color:#fff;border:none;border-radius:999px;"
  + "padding:15px 14px;font-family:inherit;font-size:14px;font-weight:800;text-transform:uppercase;"
  + "letter-spacing:.03em;cursor:pointer;min-width:0;box-sizing:border-box;transition:background .15s}"
  + ".nv6-atc:hover{background:#E62E8C}"
  + ".nv6-atc[disabled]{background:#5a534f;color:rgba(255,255,255,.6);cursor:default}"
  + ".nv6-atc.nv6-out{background:transparent;color:#fff;box-shadow:inset 0 0 0 2px rgba(255,255,255,.35)}"
  + ".nv6-atc.nv6-out:hover{background:transparent;box-shadow:inset 0 0 0 2px rgba(255,255,255,.7)}"
  + "@media(max-width:767px){"
  + ".nv6-lb{padding:56px 14px 18px}"
  + ".nv6-box{gap:12px}"
  + ".nv6-media img{max-height:min(56vh,460px)}"
  + ".nv6-lb.nv6-kit .nv6-media img{max-height:min(60vh,500px)}"
  + ".nv6-t{font-size:17px}"
  + ".nv6-x{top:10px;right:10px}"
  + "}";

  var st = document.createElement("style");
  st.textContent = css;
  document.head.appendChild(st);

  function money(c) { return "$" + (c / 100).toFixed(2); }
  function esc(s) {
    return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;")
      .replace(/>/g, "&gt;").replace(/\"/g, "&quot;");
  }

  /* ---- Shopify CDN sizing -------------------------------------------
     products.js hands back the ORIGINAL file: swatches are 3024x3024,
     inspo shots 1080x1920. The main photo is capped at 430x440 CSS and
     the thumbs paint at 42px, so an untouched src ships between 20x and
     5000x more pixels than anything here can show. Worse, the thumb
     strip is in view the moment the box opens -- loading="lazy" never
     fires -- so EVERY frame's original downloads at once. That is the
     whole of the "gallery is slow" report; the markup was never the
     problem.

     _WxH is a bounding box: fit, no crop, no upscale. Square on purpose.
     A 9:16 photo asked for _900x comes back 900x1600, three times the
     pixels of the 506x900 it actually needs -- width-only suffixes are
     the trap here, not the fix.

     900 = the 440px height cap at 2x, with room for the 430px-wide
     square swatches. 200 = the 42px thumb at ~3x even after object-fit
     crops the short side. Raise these if the caps in the stylesheet
     above ever move; they are the only reason these two numbers exist.
     -------------------------------------------------------------------- */
  function sized(src, px) {
    if (!src) return "";
    if (src.indexOf("/cdn/") === -1 && src.indexOf("cdn.shopify") === -1) return src;
    if (/_\d+x\d*(_crop_\w+)?\.\w+(\?|$)/.test(src)) return src;
    return src.replace(/(\.\w+)(\?|$)/, "_" + px + "x" + px + "$1$2");
  }

  var ICO_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>';
  var ICO_L = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>';
  var ICO_R = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>';

  var ICO_ZI = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.1-4.1M11 8v6M8 11h6"/></svg>';
  var ICO_ZO = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.1-4.1M8 11h6"/></svg>';

  var lb = document.createElement("div");
  lb.className = "nv6-lb";
  lb.setAttribute("role", "dialog");
  lb.setAttribute("aria-modal", "true");
  lb.innerHTML =
      '<button type="button" class="nv6-x" data-x aria-label="Close">' + ICO_X + '</button>'
    + '<div class="nv6-box">'
    +   '<div class="nv6-media">'
    +     '<img data-img alt="">'
    +     '<button type="button" class="nv6-nav nv6-prev" data-prev aria-label="Previous">' + ICO_L + '</button>'
    +     '<button type="button" class="nv6-nav nv6-next" data-next aria-label="Next">' + ICO_R + '</button>'
    +     '<button type="button" class="nv6-zoom" data-zoom aria-label="Zoom in"></button>'
    +     '<span class="nv6-cnt" data-cnt></span>'
    +   '</div>'
    +   '<div class="nv6-panel">'
    +     '<div class="nv6-t"><span data-t></span><small data-sub></small></div>'
    +     '<div class="nv6-th" data-th></div>'
    +     '<div class="nv6-size" data-size></div>'
    +     '<div class="nv6-prog" data-prog></div>'
    +     '<button type="button" class="nv6-atc" data-atc></button>'
    +   '</div>'
    + '</div>';
  document.body.appendChild(lb);

  var elT = lb.querySelector("[data-t]"), elSub = lb.querySelector("[data-sub]"),
      elImg = lb.querySelector("[data-img]"), elTh = lb.querySelector("[data-th]"),
      elCnt = lb.querySelector("[data-cnt]"), elSize = lb.querySelector("[data-size]"),
      elProg = lb.querySelector("[data-prog]"), elAtc = lb.querySelector("[data-atc]"),
      elPrev = lb.querySelector("[data-prev]"), elNext = lb.querySelector("[data-next]"),
      elMedia = lb.querySelector(".nv6-media"), elZoom = lb.querySelector("[data-zoom]");

  /* custom !== null puts the gallery in KIT mode: no size picker, no cart,
     one caller-supplied action. */
  var S = { imgs: [], i: 0, sizes: [], sel: 0, card: null, title: "", custom: null,
            z: false, zx: 50, zy: 38 };

  function paint() {
    if (!S.imgs.length) return;
    setZoom(false);
    elImg.src = sized(S.imgs[S.i].src, 1200);
    elImg.alt = S.title;
    elCnt.textContent = (S.i + 1) + " / " + S.imgs.length;
    syncNav();
    var btns = elTh.querySelectorAll("button");
    for (var k = 0; k < btns.length; k++) btns[k].classList.toggle("on", k === S.i);
    if (btns[S.i] && btns[S.i].scrollIntoView) {
      btns[S.i].scrollIntoView({ block: "nearest", inline: "nearest" });
    }
  }
  function step(d) {
    var n = S.imgs.length;
    if (n < 2) return;
    S.i = (S.i + d + n) % n;
    paint();
  }
  function close() {
    lb.classList.remove("show");
    document.documentElement.style.overflow = "";
  }

  /* ---- 2x tap zoom ----------------------------------------------------
     ONE handler owns the entire photo area. The prototype gave the
     magnifier its own click listener ON TOP of the photo's, so a single tap
     ran both, the two toggles cancelled, and the button looked dead. Never
     split this: whatever was tapped is decided here and returned from here.
     The arrows sit inside .nv6-media too and are bailed out on the first
     line for the same reason -- without it a tap on "next" would step the
     frame AND zoom it.

     Tap the photo -> 2x centred on that point. Tap the magnifier -> 2x at
     50%/38%, which is where the nails sit in a 9:16 hand shot. Drag ->
     pan. Tap again -> out.

     Panning moves transform-origin instead of translating the image, so it
     can never be dragged off its own frame and there is no clamping maths
     to get wrong -- 0..100% IS the bound.

     While zoomed, arrows and counter are hidden and swipe-to-change is off,
     because a drag now means pan. Changing frame always resets zoom, or the
     next photo opens already shoved into a corner. */
  function syncNav() {
    var hide = S.imgs.length < 2 || S.z;
    elPrev.style.display = hide ? "none" : "";
    elNext.style.display = hide ? "none" : "";
    elCnt.style.display = hide ? "none" : "";
  }
  function setZoom(on, x, y) {
    S.z = !!on;
    if (S.z) { S.zx = (x == null ? 50 : x); S.zy = (y == null ? 38 : y); }
    elImg.style.transformOrigin = S.zx + "% " + S.zy + "%";
    elImg.style.transform = S.z ? "scale(2)" : "scale(1)";
    elZoom.innerHTML = S.z ? ICO_ZO : ICO_ZI;
    elZoom.setAttribute("aria-label", S.z ? "Zoom out" : "Zoom in");
    lb.classList.toggle("nv6-zoomed", S.z);
    syncNav();
  }
  function pct(v, lo, hi) { return Math.max(0, Math.min(100, (v - lo) / hi * 100)); }

  var pd = null;
  elMedia.addEventListener("pointerdown", function (e) {
    if (e.target.closest("[data-prev]") || e.target.closest("[data-next]")) return;
    pd = { x: e.clientX, y: e.clientY, moved: 0, onBtn: !!e.target.closest("[data-zoom]") };
    try { elMedia.setPointerCapture(e.pointerId); } catch (err) {}
  });
  elMedia.addEventListener("pointermove", function (e) {
    if (!pd) return;
    pd.moved += Math.abs(e.clientX - pd.x) + Math.abs(e.clientY - pd.y);
    if (S.z && !pd.onBtn) {
      var r = elMedia.getBoundingClientRect();
      S.zx = Math.max(0, Math.min(100, S.zx - (e.clientX - pd.x) / r.width * 100));
      S.zy = Math.max(0, Math.min(100, S.zy - (e.clientY - pd.y) / r.height * 100));
      elImg.style.transition = "none";
      elImg.style.transformOrigin = S.zx + "% " + S.zy + "%";
    }
    pd.x = e.clientX; pd.y = e.clientY;
  });
  elMedia.addEventListener("pointerup", function (e) {
    if (!pd) return;
    var tap = pd.moved < 6, onBtn = pd.onBtn;
    pd = null;
    elImg.style.transition = "";
    if (!tap) return;
    if (S.z) return setZoom(false);
    if (onBtn) return setZoom(true, 50, 38);
    var r = elMedia.getBoundingClientRect();
    setZoom(true, pct(e.clientX, r.left, r.width), pct(e.clientY, r.top, r.height));
  });
  elMedia.addEventListener("pointercancel", function () {
    pd = null; elImg.style.transition = "";
  });

  /* KIT footer. The caller owns the state, so it hands us a describe()
     that returns { progress, label, kind } and we redraw after every tap. */
  function paintCustom() {
    elSize.style.display = "none";
    elProg.style.display = "";
    var d = {};
    try { d = S.custom.describe() || {}; } catch (err) { d = {}; }
    elProg.innerHTML = d.progress || "";
    elAtc.textContent = d.label || "";
    elAtc.disabled = !!d.disabled;
    elAtc.className = "nv6-atc" + (d.kind === "remove" ? " nv6-out" : "");
  }

  function paintSizes() {
    elProg.style.display = "none";
    if (S.sizes.length < 2) {
      elSize.innerHTML = "";
      elSize.style.display = "none";
    } else {
      elSize.style.display = "";
      elSize.innerHTML = S.sizes.map(function (v, k) {
        var cmp = (v.compare_at_price && v.compare_at_price > v.price)
          ? ' <s>' + money(v.compare_at_price) + '</s>' : '';
        return '<button type="button" class="nv6-sz' + (k === S.sel ? ' on' : '') + '" data-k="' + k + '">'
             + '<b>' + esc(v.label) + '</b><span class="p">' + money(v.price) + cmp + '</span></button>';
      }).join("");
    }
    var cur = S.sizes[S.sel];
    elAtc.className = "nv6-atc";
    if (!cur) { elAtc.textContent = "Unavailable"; elAtc.disabled = true; return; }
    elAtc.disabled = !cur.available;
    elAtc.textContent = cur.available ? ("Add to bag \u00b7 " + money(cur.price)) : "Sold out";
  }

  function paintFooter() { if (S.custom) paintCustom(); else paintSizes(); }

  /* Collection path only. Reuses the card's own quick-add so the queue,
     429 backoff, toast and mini-cart refresh all run untouched. Never
     posts to /cart/add.js here. */
  function addToCart() {
    var cur = S.sizes[S.sel];
    if (!cur || !cur.available || !S.card) return;
    var qa = S.card.querySelector(".nagaia-quick-add");
    if (!qa) return;
    var prevId = qa.getAttribute("data-variant-id"),
        prevCents = qa.getAttribute("data-cents");
    qa.setAttribute("data-variant-id", String(cur.id));
    qa.setAttribute("data-cents", String(cur.price));
    qa.click();
    /* hand the card back to applySize(), which owns that value */
    setTimeout(function () {
      if (prevId) qa.setAttribute("data-variant-id", prevId);
      if (prevCents) qa.setAttribute("data-cents", prevCents);
    }, 900);
    close();
  }

  function open(cfg) {
    S.card = cfg.card || null;
    S.title = cfg.title || "";
    S.custom = cfg.custom || null;
    S.i = 0; S.sel = 0; S.imgs = []; S.sizes = [];
    elT.textContent = S.title;
    elSub.textContent = "\u2026";
    elTh.innerHTML = ""; elCnt.textContent = "";
    elSize.innerHTML = ""; elProg.innerHTML = "";
    elImg.removeAttribute("src");
    lb.classList.toggle("nv6-kit", !!S.custom);
    setZoom(false);
    elAtc.textContent = ""; elAtc.disabled = true; elAtc.className = "nv6-atc";
    lb.classList.add("show");
    document.documentElement.style.overflow = "hidden";

    fetch("/products/" + cfg.handle + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        (p.media || []).forEach(function (m) {
          if (m.media_type === "image" && m.src) S.imgs.push({ src: m.src });
        });
        /* 0.5 oz and 1 oz only -- 2 oz is not offered from the grid */
        (p.variants || []).forEach(function (v) {
          var t = String(v.title || "").toLowerCase(), label = null;
          if (t.indexOf("0.5") !== -1) label = "0.5 oz";
          else if (t.indexOf("1 oz") !== -1 || t.indexOf("1oz") !== -1) label = "1 oz";
          if (!label) return;
          S.sizes.push({ id: v.id, label: label, price: v.price,
            compare_at_price: v.compare_at_price, available: v.available });
        });
        if (!S.sizes.length && (p.variants || []).length) {
          var v0 = p.variants[0];
          S.sizes.push({ id: v0.id, label: v0.title, price: v0.price,
            compare_at_price: v0.compare_at_price, available: v0.available });
        }
        S.sizes.sort(function (a, b) { return a.price - b.price; });

        var nInsp = 0;
        (p.media || []).forEach(function (m) {
          if (m.alt && String(m.alt).toLowerCase().indexOf("nail insp") !== -1) nInsp++;
        });
        elSub.textContent = (cfg.sku ? cfg.sku + " \u00b7 " : "") + S.imgs.length + " photos"
          + (nInsp ? " \u00b7 " + nInsp + " on real nails" : "");

        elTh.innerHTML = S.imgs.map(function (m, k) {
          return '<button type="button" data-k="' + k + '"' + (k === 0 ? ' class="on"' : '')
               + ' aria-label="Photo ' + (k + 1) + '"><img src="' + esc(sized(m.src, 200)) + '" alt="" loading="lazy"></button>';
        }).join("");
        paint();
        paintFooter();
      })
      .catch(function () {
        elSub.textContent = "Could not load photos";
        elAtc.textContent = "Close";
        elAtc.disabled = false;
        elAtc.className = "nv6-atc nv6-out";
      });
  }

  /* Public API. sections/nagaia-kit-builder.liquid calls this; it falls back
     to its own small zoom when the gallery or a main-product handle is
     missing, so a colour never loses its zoom. */
  window.NagaiaColorGallery = {
    open: function (cfg) { if (cfg && cfg.handle) open(cfg); },
    refresh: function () { if (lb.classList.contains("show")) paintFooter(); },
    close: close
  };

  /* Collection cards. Delegated: filters and Load more rebuild the grid, so
     per-node binding would go stale. */
  document.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest("[data-nv6]");
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    open({
      card: b.closest(".product-block"),
      handle: b.getAttribute("data-nv6"),
      title: b.getAttribute("data-nv6-title") || ""
    });
  }, true);

  lb.addEventListener("click", function (e) {
    if (e.target === lb || e.target.classList.contains("nv6-box")) return close();
    if (e.target.closest("[data-x]")) return close();
    if (e.target.closest("[data-prev]")) return step(-1);
    if (e.target.closest("[data-next]")) return step(1);
    var t = e.target.closest(".nv6-th button");
    if (t) { S.i = +t.getAttribute("data-k"); paint(); return; }
    var s = e.target.closest(".nv6-sz");
    if (s) { S.sel = +s.getAttribute("data-k"); paintSizes(); return; }
    if (e.target.closest("[data-atc]")) {
      if (elAtc.disabled) return;
      if (S.custom) {
        try { S.custom.onAction(); } catch (err) {}
        paintCustom();
        return;
      }
      if (elAtc.textContent === "Close") return close();
      return addToCart();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (!lb.classList.contains("show")) return;
    if (e.key === "Escape") close();
    else if (e.key === "ArrowLeft") step(-1);
    else if (e.key === "ArrowRight") step(1);
  });

  var tx = null;
  /* A pinch used to register as a swipe: touches[0] was recorded, the second
     finger moved it well past 45px, and letting go jumped to the next photo.
     Bail on any second finger, and on zoom, where a drag means pan. */
  lb.addEventListener("touchstart", function (e) {
    tx = (e.touches.length === 1 && !S.z) ? e.touches[0].clientX : null;
  }, { passive: true });
  lb.addEventListener("touchmove", function (e) {
    if (e.touches.length > 1) tx = null;
  }, { passive: true });
  lb.addEventListener("touchend", function (e) {
    if (tx == null) return;
    var dx = e.changedTouches[0].clientX - tx;
    tx = null;
    if (Math.abs(dx) > 45) step(dx < 0 ? 1 : -1);
  }, { passive: true });
})();
